import React from 'react';
import PropTypes from 'prop-types';
import Link from '../link';

const Email = ({ address }) => (
  <Link
    href={`mailto:${address}`}
  >
    {address}
  </Link>
);

Email.propTypes = {
  address: PropTypes.string.isRequired,
};

export default Email;



// WEBPACK FOOTER //
// ./src/app/components/email/index.js